import React, { useState, useEffect, useCallback } from 'react';
import { toast } from 'sonner';
import { CalendarDays } from 'lucide-react';

const STATUS_STYLES = {
  confirmed: 'bg-green-50 text-green-700 border-green-200',
  tentative: 'bg-amber-50 text-amber-700 border-amber-200',
  cancelled: 'bg-red-50 text-red-600 border-red-200'
};

export const OwnerBookings = ({ api }) => {
  const [bookings, setBookings] = useState(null);

  const load = useCallback(async () => {
    try {
      const res = await api.get('/owner/bookings');
      setBookings(res.data.bookings || []);
    } catch {
      toast.error('Failed to load bookings');
    }
  }, [api]);

  useEffect(() => { load(); }, [load]);

  if (!bookings) return <p className="text-sm text-[#1A3626]/50 py-8 text-center">Loading bookings…</p>;

  return (
    <div className="bg-white border border-[#E5DCCF] rounded-2xl overflow-hidden" data-testid="owner-bookings">
      <div className="px-6 py-4 border-b border-[#E5DCCF] bg-[#FDFCF8]">
        <h3 className="font-wvc-display text-2xl text-[#0A1710]">Booking Confirmations</h3>
        <p className="text-xs text-[#1A3626]/60 mt-1">Bookings confirmed and updated by the WVC team for your venue.</p>
      </div>
      {bookings.length === 0 ? (
        <p className="text-sm text-[#1A3626]/50 py-12 text-center">No bookings recorded yet.</p>
      ) : (
        <div className="divide-y divide-[#F3EFEB]">
          {bookings.map((b, i) => (
            <div key={b.id} className="px-6 py-4 flex items-start justify-between gap-4 flex-wrap" data-testid={`owner-booking-${i}`}>
              <div>
                <p className="font-medium text-[#0A1710]">{b.title}</p>
                <p className="text-xs text-[#1A3626]/60 mt-1 flex items-center gap-2 flex-wrap">
                  <span className="flex items-center gap-1"><CalendarDays className="w-3 h-3" /> {b.event_date}{b.end_date ? ` → ${b.end_date}` : ''}</span>
                  {b.customer_name && <span>· {b.customer_name}</span>}
                  {b.amount_label && <span>· {b.amount_label}</span>}
                </p>
                {b.notes && <p className="text-xs text-[#1A3626]/50 mt-1">{b.notes}</p>}
              </div>
              <span className={`text-[11px] uppercase tracking-wider font-semibold border px-2.5 py-1 rounded-full ${STATUS_STYLES[b.status] || STATUS_STYLES.tentative}`}>
                {b.status}
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
